import { render, staticRenderFns } from "./customer-order-count.vue?vue&type=template&id=376a7c10&scoped=true"
import script from "./customer-order-count.vue?vue&type=script&lang=js"
export * from "./customer-order-count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a7c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376a7c10')) {
      api.createRecord('376a7c10', component.options)
    } else {
      api.reload('376a7c10', component.options)
    }
    module.hot.accept("./customer-order-count.vue?vue&type=template&id=376a7c10&scoped=true", function () {
      api.rerender('376a7c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stat-analyze/customer-analyze/customer-order-count.vue"
export default component.exports